// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"621":"dd21e044","884":"e6d7c9ff"}[chunkId] + ".chunk.css";
};